module.exports = __webpack_public_path__ + "static/media/cancer-grande.777bfe77.jpg";